export default __webpack_public_path__ + "static/media/manipal-logo.526434eb.svg";